<template>
  <div class="wrapper">
    <div class="iq-sidebar sidebar-default">
      <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
  <a href="/" class="header-logo w-100 d-flex align-items-center justify-content-center">
    <img
      src="assets/images/logo.jpeg"
      class="img-fluid h-100"
      alt="logo"
    />
  </a>
  <div class="iq-menu-bt-sidebar ml-0">
    <i class="las la-bars wrapper-menu"></i>
  </div>
</div>
      <div class="data-scrollbar" data-scroll="1">
        <nav class="iq-sidebar-menu">
          <ul id="iq-sidebar-toggle" class="iq-menu">
            <li class="active">
              <a href="/" class="svg-icon">
                <svg
                  class="svg-icon"
                  id="p-dash1"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                  ></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <span class="ml-4">Dashboards</span>
              </a>
            </li>
            <li class=" ">
              <a
                href="#category"
                class="collapsed"
                data-toggle="collapse"
                aria-expanded="false"
              >
                <svg
                  class="svg-icon"
                  id="p-dash3"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path
                    d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                  ></path>
                </svg>
                <span class="ml-4">Currencies</span>
                <svg
                  class="svg-icon iq-arrow-right arrow-active"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="10 15 15 20 20 15"></polyline>
                  <path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                </svg>
              </a>
              <ul
                id="category"
                class="iq-submenu collapse"
                data-parent="#iq-sidebar-toggle"
              >
                <li class="">
                  <a href="/currencies">
                    <i class="las la-minus"></i><span>Record Currencies</span>
                  </a>
                </li>
                <li class="">
                  <a href="/exchange-rate">
                    <i class="las la-minus"></i><span>Exchange Rate</span>
                  </a>
                </li>
                <li class="">
                  <a href="/transactions">
                    <i class="las la-minus"></i><span>Transactions</span>
                  </a>
                </li>
                <li class="">
                  <a href="/clients">
                    <i class="las la-minus"></i><span>Clients</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="">
              <a href="/reports" class="">
                <svg
                  class="svg-icon"
                  id="p-dash7"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  ></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span class="ml-4">Reports</span>
              </a>
              <ul
                id="reports"
                class="iq-submenu collapse"
                data-parent="#iq-sidebar-toggle"
              ></ul>
            </li>
          </ul>
        </nav><br><br><br><br>
        <div id="sidebar-bottom" class="position-relative sidebar-bottom">
          <div class="card border-none">
            <!-- <div class="card-body p-0">
              <div class="sidebarbottom-content">
                <div class="image">
                  <img
                    src="assets/images/about-tg.png"
                    class="img-fluid"
                    alt="side-bkg"
                  />
                </div>
                <h6 class="mt-4 px-4 body-title">
                  Need a Professional Website? 🚀 Call or Text Tamba Group +250 789 326 245
                </h6>
                <a href="https://tambagroup.xyz/" class="btn sidebar-bottom-btn mt-4">
                  Learn More
                </a>
              </div>
            </div> -->
          </div>
        </div>
        <div class="p-3"></div>
      </div>
    </div>
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <div
            class="iq-navbar-logo d-flex align-items-center justify-content-between"
          >
            <i class="ri-menu-line wrapper-menu"></i>
            <a href="backend/index.html" class="header-logo">
              <img
                src="assets/images/logo.png"
                class="img-fluid rounded-normal"
                alt="logo"
              />
              <h5 class="logo-title ml-3">POSDash</h5>
            </a>
          </div>
          <div class="iq-search-bar device-search">
            <form action="#" class="searchbox">
              <a class="search-link" href="#"><i class="ri-search-line"></i></a>
              <input
                type="text"
                class="text search-input"
                placeholder="Search here..."
              />
            </form>
          </div>
          <div class="d-flex align-items-center">
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-label="Toggle navigation"
            >
              <i class="ri-menu-3-line"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto navbar-list align-items-center">
                <li class="nav-item nav-icon dropdown">
                  <a
                    href="#"
                    class="search-toggle dropdown-toggle btn border add-btn"
                    id="dropdownMenuButton02"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src="assets/images/small/flag-01.png"
                      alt="img-flag"
                      class="img-fluid image-flag mr-2"
                    />En
                  </a>
                  <div
                    class="iq-sub-dropdown dropdown-menu"
                    aria-labelledby="dropdownMenuButton2"
                  >
                    <div class="card shadow-none m-0">
                      <div class="card-body p-3">
                        <a class="iq-sub-card" href="#"
                          ><img
                            src="assets/images/small/flag-02.png"
                            alt="img-flag"
                            class="img-fluid mr-2"
                          />French</a
                        >
                        <a class="iq-sub-card" href="#"
                          ><img
                            src="assets/images/small/flag-03.png"
                            alt="img-flag"
                            class="img-fluid mr-2"
                          />Spanish</a
                        >
                        <a class="iq-sub-card" href="#"
                          ><img
                            src="assets/images/small/flag-04.png"
                            alt="img-flag"
                            class="img-fluid mr-2"
                          />Italian</a
                        >
                        <a class="iq-sub-card" href="#"
                          ><img
                            src="assets/images/small/flag-05.png"
                            alt="img-flag"
                            class="img-fluid mr-2"
                          />German</a
                        >
                        <a class="iq-sub-card" href="#"
                          ><img
                            src="assets/images/small/flag-06.png"
                            alt="img-flag"
                            class="img-fluid mr-2"
                          />Japanese</a
                        >
                      </div>
                    </div>
                  </div>
                </li>
                <li class="nav-item nav-icon search-content">
                  <a
                    href="#"
                    class="search-toggle rounded"
                    id="dropdownSearch"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="ri-search-line"></i>
                  </a>
                  <div
                    class="iq-search-bar iq-sub-dropdown dropdown-menu"
                    aria-labelledby="dropdownSearch"
                  >
                    <form action="#" class="searchbox p-2">
                      <div class="form-group mb-0 position-relative">
                        <input
                          type="text"
                          class="text search-input font-size-12"
                          placeholder="type here to search..."
                        />
                        <a href="#" class="search-link"
                          ><i class="las la-search"></i
                        ></a>
                      </div>
                    </form>
                  </div>
                </li>
                <li class="nav-item nav-icon dropdown">
                  <a
                    href="#"
                    class="search-toggle dropdown-toggle"
                    id="dropdownMenuButton2"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-mail"
                    >
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      ></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <span class="bg-primary"></span>
                  </a>
                  <div
                    class="iq-sub-dropdown dropdown-menu"
                    aria-labelledby="dropdownMenuButton2"
                  >
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0">
                        <div class="cust-title p-3">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <h5 class="mb-0">All Messages</h5>
                            <a class="badge badge-primary badge-card" href="#"
                              >3</a
                            >
                          </div>
                        </div>
                        <div class="px-3 pt-0 pb-0 sub-card">
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3 border-bottom"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/01.jpg"
                                  alt="01"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Emma Watson</h6>
                                  <small class="text-dark"
                                    ><b>12 : 47 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3 border-bottom"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/02.jpg"
                                  alt="02"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Ashlynn Franci</h6>
                                  <small class="text-dark"
                                    ><b>11 : 30 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/03.jpg"
                                  alt="03"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Kianna Carder</h6>
                                  <small class="text-dark"
                                    ><b>11 : 21 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                        </div>
                        <a
                          class="right-ic btn btn-primary btn-block position-relative p-2"
                          href="#"
                          role="button"
                        >
                          View All
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="nav-item nav-icon dropdown">
                  <a
                    href="#"
                    class="search-toggle dropdown-toggle"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-bell"
                    >
                      <path
                        d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                      ></path>
                      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                    <span class="bg-primary"></span>
                  </a>
                  <div
                    class="iq-sub-dropdown dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0">
                        <div class="cust-title p-3">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <h5 class="mb-0">Notifications</h5>
                            <a class="badge badge-primary badge-card" href="#"
                              >3</a
                            >
                          </div>
                        </div>
                        <div class="px-3 pt-0 pb-0 sub-card">
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3 border-bottom"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/01.jpg"
                                  alt="01"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Emma Watson</h6>
                                  <small class="text-dark"
                                    ><b>12 : 47 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3 border-bottom"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/02.jpg"
                                  alt="02"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Ashlynn Franci</h6>
                                  <small class="text-dark"
                                    ><b>11 : 30 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                          <a href="#" class="iq-sub-card">
                            <div
                              class="media align-items-center cust-card py-3"
                            >
                              <div class="">
                                <img
                                  class="avatar-50 rounded-small"
                                  src="assets/images/user/03.jpg"
                                  alt="03"
                                />
                              </div>
                              <div class="media-body ml-3">
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <h6 class="mb-0">Kianna Carder</h6>
                                  <small class="text-dark"
                                    ><b>11 : 21 pm</b></small
                                  >
                                </div>
                                <small class="mb-0"
                                  >Lorem ipsum dolor sit amet</small
                                >
                              </div>
                            </div>
                          </a>
                        </div>
                        <a
                          class="right-ic btn btn-primary btn-block position-relative p-2"
                          href="#"
                          role="button"
                        >
                          View All
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="nav-item nav-icon dropdown caption-content">
                  <a
                    href="#"
                    class="search-toggle dropdown-toggle"
                    id="dropdownMenuButton4"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src="assets/images/user/1.png"
                      class="img-fluid rounded"
                      alt="user"
                    />
                  </a>
                  <div
                    class="iq-sub-dropdown dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0 text-center">
                        <div class="media-body profile-detail text-center">
                          <img
                            src="assets/images/logo.jpeg"
                            alt="profile-bg"
                            class="rounded-top img-fluid mb-4"
                          />
                          <img
                            src="assets/images/user/1.png"
                            alt="profile-img"
                            class="rounded profile-img img-fluid avatar-70"
                          />
                        </div>
                        <div class="p-3">
                          <h5 class="mb-1">{{ user.email }}</h5>
                          <p class="mb-0">
                            Since {{ formatDate(user.created_at) }}
                          </p>
                          <div
                            class="d-flex align-items-center justify-content-center mt-3"
                          >
                            <router-link
                              to="/user-profile"
                              class="btn border mr-2"
                              >Profile</router-link
                            >
                            <!-- <router-link to="/company-profile" class="btn border mr-2">Company</router-link> -->
                            <button @click="logout" class="btn border">
                              Sign Out
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <router-view name="dashboard"></router-view>
  </div>
  <!-- Wrapper End-->
  <footer class="iq-footer">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  <a href="#">Privacy Policy</a>
                </li>
                <li class="list-inline-item">
                  <a href="#">Terms of Use</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-6 text-right">
              <span class="mr-1"> © </span>
              <a href="#" class="">Forex Bureau</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  setup () {
    const router = useRouter()
    const user = ref({ email: '', created_at: '' })
    const companyName = ref('Forex Bureau')
    const isCategoryOpen = ref(false)

    const fetchUserData = () => {
      const userData = localStorage.getItem('user')
      if (userData) {
        user.value = JSON.parse(userData)
      } else {
        router.push('/auth-sign-in')
      }
    }

    const logout = () => {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      router.push('/auth-sign-in')
    }

    const formatDate = (date: string) => {
      return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    }

    const toggleCategory = () => {
      isCategoryOpen.value = !isCategoryOpen.value
    }

    onMounted(() => {
      fetchUserData()
    })

    return {
      user,
      companyName,
      isCategoryOpen,
      logout,
      formatDate,
      toggleCategory
    }
  }
})
</script>
